var _title, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgJuniorStudioArrowDown = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 226.45 150",
    ref: svgRef
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Asset 1")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 96.55,
    y: 55.37,
    width: 150.53,
    height: 39.27,
    transform: "matrix(0.5, -0.87, 0.87, 0.5, 20.96, 186.3)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: -0.27,
    width: 39.27,
    height: 150.53,
    transform: "translate(-30.18 37.37) rotate(-30)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgJuniorStudioArrowDown, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Junior_Studio_ARROW_DOWN.09afe725.svg";
export { ForwardRef as ReactComponent };